export default (state, action) => ({
  ...state,
  windowCategoryMappings: { ...action.payload },
});
